/** @format */

/** 会话分析页内容区：侧栏筛选 + 列表表格，共享 sessionSearch.Filters */

import React, { useState } from 'react'
import { useLocation } from 'react-router'
import styled from 'styled-components'
import { TableSearch, parseTableSearchParams } from 'src/components'
import { ServiceOverviewSearchProps } from '../../components/typescript.js'
import { SessionAnalysisSearchProps } from '../typescript'
import { initSessionAnalysisSearc } from '../constant'
import SessionSearch from './SessionSearch'
import SessionTable from './SessionTable'

interface SessionContainerProps {
  className?: string
  headerSearch: ServiceOverviewSearchProps
  serviceName?: string
  region?: string
}

const SessionContainer: React.FC<SessionContainerProps> = ({
  className,
  headerSearch,
  serviceName,
  region
}) => {
  const location = useLocation()
  const [sessionSearch, setSessionSearch] = useState<SessionAnalysisSearchProps>(() => {
    const urlParmas = parseTableSearchParams(location.search, 'sessionSearch') || {}
    return {
      ...initSessionAnalysisSearc,
      // 从服务详情跳入时预填服务名
      Filters: serviceName
        ? [
            {
              Key: 'service_name',
              Op: 'in',
              Values: [serviceName]
            }
          ]
        : initSessionAnalysisSearc.Filters,
      ...urlParmas
    }
  })

  return (
    <div className={className}>
      <TableSearch params={sessionSearch} paramsKey="sessionSearch" noStyle>
        <SessionSearch
          headerSearch={headerSearch}
          serviceName={serviceName}
          value={sessionSearch.Filters}
          onChange={filters => setSessionSearch({ ...sessionSearch, Page: 1, Filters: filters })}
        />
      </TableSearch>
      <SessionTable
        headerSearch={headerSearch}
        serviceName={serviceName}
        sessionSearch={sessionSearch}
        setSessionSearch={setSessionSearch}
        region={region}
      />
    </div>
  )
}

export default styled(SessionContainer)`
  width: 100%;
  display: flex;
`
